module.exports = __webpack_public_path__ + "static/media/reportonce-logo.8bf98006.svg";